import _objectWithoutProperties from "/home/runner/work/documentation/documentation/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/runner/work/documentation/documentation/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["children", "as", "sx"],
  _excluded2 = ["leadingIcon", "trailingIcon", "variant", "size"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef, useMemo } from 'react';
import Box from '../Box.js';
import '../sx.js';
import { useTheme } from '../ThemeProvider.js';
import { StyledButton } from './types.js';
import { getButtonStyles, getSizeStyles, getVariantStyles } from './styles.js';
import { useRefObjectAsForwardedRef } from '../hooks/useRefObjectAsForwardedRef.js';
import merge from 'deepmerge';
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var defaultSxProp = {};
var iconWrapStyles = {
  display: 'inline-block'
};
var trailingIconStyles = _objectSpread(_objectSpread({}, iconWrapStyles), {}, {
  ml: 2
});
var ButtonBase = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'button' : _ref$as,
    _ref$sx = _ref.sx,
    sxProp = _ref$sx === void 0 ? defaultSxProp : _ref$sx,
    props = _objectWithoutProperties(_ref, _excluded);
  var LeadingIcon = props.leadingIcon,
    TrailingIcon = props.trailingIcon,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'default' : _props$variant,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    rest = _objectWithoutProperties(props, _excluded2);
  var innerRef = React.useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  var _useTheme = useTheme(),
    theme = _useTheme.theme;
  var baseStyles = useMemo(function () {
    return merge.all([getButtonStyles(theme), getSizeStyles(size, variant, false), getVariantStyles(variant, theme)]);
  }, [theme, size, variant]);
  var sxStyles = useMemo(function () {
    return merge(baseStyles, sxProp);
  }, [baseStyles, sxProp]);
  if (process.env.NODE_ENV !== 'production') {
    /**
     * The Linter yells because it thinks this conditionally calls an effect,
     * but since this is a compile-time flag and not a runtime conditional
     * this is safe, and ensures the entire effect is kept out of prod builds
     * shaving precious bytes from the output, and avoiding mounting a noop effect
     */
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (!(innerRef.current instanceof HTMLButtonElement) && !(innerRef.current instanceof HTMLAnchorElement)) {
        // eslint-disable-next-line no-console
        console.warn('This component should be an instanceof a semantic button or anchor');
      }
    }, [innerRef]);
  }
  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    as: Component,
    sx: sxStyles
  }, rest, {
    ref: innerRef
  }), LeadingIcon && /*#__PURE__*/React.createElement(Box, {
    as: "span",
    "data-component": "leadingIcon",
    sx: iconWrapStyles
  }, /*#__PURE__*/React.createElement(LeadingIcon, null)), children && /*#__PURE__*/React.createElement("span", {
    "data-component": "text"
  }, children), TrailingIcon && /*#__PURE__*/React.createElement(Box, {
    as: "span",
    "data-component": "trailingIcon",
    sx: trailingIconStyles
  }, /*#__PURE__*/React.createElement(TrailingIcon, null)));
});
export { ButtonBase };